module.exports = __webpack_public_path__ + "static/media/bublegum.2c9b45c9.gif";